import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  files: [],
  uploadProgress: 0,
  fileData: null,
  total: 0,
  selectedFile: null,
  selectedValidFile: null,
  selectedSplitFile: null,
  selectedAdvisorFile: null,
};

const name = 'uploads';
const parentSelector = state => state?.[name];

const filesSlice = createSlice({
  name: name,
  initialState: initialState,
  reducers: {
    setFiles: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setUploadProgress: (state, action) => {
      return {
        ...state,
        uploadProgress: action.payload,
      };
    },
    setFileData: (state, action) => {
      return {
        ...state,
        fileData: action.payload,
      };
    },
    setSelectedFile: (state, action) => {
      return {
        ...state,
        selectedFile: action.payload,
      };
    },
    setSelectedValidFile: (state, action) => {
      return {
        ...state,
        selectedValidFile: action.payload,
      };
    },
    setSelectedSplitFile: (state, action) => {
      return {
        ...state,
        selectedSplitFile: action.payload,
      };
    },
    setSelectedAdvisorFile: (state, action) => {
      return {
        ...state,
        selectedAdvisorFile: action.payload,
      };
    },
  },
});

const getFiles = createSelector(parentSelector, state => state?.files);
const getFileData = createSelector(parentSelector, state => state?.fileData);
const getUplaodProgress = createSelector(
  parentSelector,
  state => state?.uploadProgress
);
const getTotalFiles = createSelector(parentSelector, state => state?.total);
const getSelectedFile = createSelector(
  parentSelector,
  state => state?.selectedFile
);
const getSelectedValidFile = createSelector(
  parentSelector,
  state => state?.selectedFile
);
const getSelectedSplitFile = createSelector(
  parentSelector,
  state => state?.selectedFile
);
const getSelectedAdvisorFile = createSelector(
  parentSelector,
  state => state?.selectedFile
);

const actions = {
  ...filesSlice.actions,
};

const selectors = {
  getFiles,
  getFileData,
  getUplaodProgress,
  getTotalFiles,
  getSelectedFile,
  getSelectedValidFile,
  getSelectedSplitFile,
  getSelectedAdvisorFile,
};

export const filesActions = { actions, selectors };

export default filesSlice;
